import { FC } from 'react'
import { StyleWrapper } from './style'
import SupportMessageHeader from './header'
import SupportMessageList from './list'
import SupportMessageFooter from './footer'
import Empty from '@commons/empty'
interface SupportMessageProps {
  receiver?: any
  sender?: any
}
const SupportMessages: FC<SupportMessageProps> = ({ receiver, sender }) => {
  return (
    <StyleWrapper>
      {!receiver?.id ? (
        <Empty />
      ) : (
        <>
          <SupportMessageHeader receiver={receiver} />
          <SupportMessageList sender={sender} receiver={receiver} />
          <SupportMessageFooter sender={sender} receiver={receiver} />
        </>
      )}
    </StyleWrapper>
  )
}

export default SupportMessages
